window.OrcamentoAbertoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-orcamento-aberto-item",
    tagName: "tr",
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    }
});

window.OrcamentoAbertoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-orcamento-aberto",
    childView: OrcamentoAbertoItemView,
    childViewContainer: "#lista-orcamento-aberto-container",

    initialize: function(options) {
        this.app = options.app;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },
});